import { Component } from '@angular/core';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { BaseComponent } from 'src/app/core/base/base.component';
import { CommonPersonModel } from 'src/app/model/common/person';
import { CommonPersonViewModel } from 'src/app/model/common/person.view';
import { PERSON } from '../person.constants';
import { PersonService } from '../person.service';

@Component({
  selector: 'ms-common-person-dialog',
  templateUrl: './person-dialog.component.html',
})
export class PersonDialogComponent extends BaseComponent {
  readonly screen = PERSON;
  person: CommonPersonModel = {};

  constructor(
    protected ref: DynamicDialogRef,
    protected config: DynamicDialogConfig,
    protected service: PersonService
  ) {
    super();
  }

  onInit = () => {
    const { personData } = this.service.readStore();
    this.subscriptions.push(
      personData.subscribe(
        (result) => (this.person = this.service.setPersonInformation(result))
      )
    );
  };

  save = () => {
    this.service.setLoadingState();
    const person = { ...this.person };
    delete person.emailHelp;
    delete person.phoneHelp;
    this.subscriptions.push(
      this.config.data.save(person).subscribe((result: CommonPersonViewModel) =>
        this.ref.close({
          ...result,
          isNew: person.isNew,
        })
      )
    );
  };
}
